import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import Utils from "./../Utils";
import _ from "lodash";
import moment from "moment";

const UserContext = createContext();

const UserProvider = (props) => {
  const [userData, setUserData] = useState(Utils.getUserData());
  const [stepData, setUCStepData] = useState({});
  const [siteStatuses, setSiteStatuses] = useState({
    status: [],
    statusToBe: [],
  });

  useEffect(() => {
    if (Utils.isLoggedIn() && siteStatuses.status.length === 0) {
      axios
        .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            setSiteStatuses({
              status: res.data.statuses,
              statusToBe: res.data.statusesToBe,
            });
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
  }, []);

  const goLogin = ({ user, pass }, callback) => {
    axios
      .post(
        Utils.apiUrl("admin/login"),
        `&username=${user}&password=${pass}`,
        Utils.apiHeaders(),
      )
      .then((res) => {
        callback(res.data);
        if (res.data.success && res.data.token) {
          setUserData(res.data.userData);
          Utils.setUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const goSSO = ({ email }, callback) => {
    const body = {
      email,
    };

    axios
      .post(Utils.apiUrl("frontend/auth/ssologin"), body, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data?.success) {
          initUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const initUserData = (data) => {
    console.log("Tokenized data received", {
      token: data.token,
      userData: data.userData,
    });
    Utils.setUserData({
      token: data.token,
      userData: data.userData,
    });
    setUserData(data.userData);
  };

  const phLogin = (data, callback) => {
    axios
      .post(Utils.apiUrl("frontend/auth"), data, Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        callback(res.data);
        if (res.data.success && res.data.token) {
          setUserData(res.data.userData);
          Utils.setUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const verifyPhotographerOtp = (data, callback) => {
    axios
      .post(Utils.apiUrl("frontend/auth/verify-otp"), data, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data.success && res.data.token) {
          initUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const hotelOwnerLogin = (data, callback) => {
    axios
      .post(Utils.apiUrl("frontend/auth/hotel-owner"), data, Utils.apiHeaders())
      .then((res) => {
        callback(res.data);
        if (res.data.success && res.data.token) {
          initUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const verifyHotelOwnerOtp = (data, callback) => {
    axios
      .post(
        Utils.apiUrl("frontend/auth/hotel-owner/verify-otp"),
        data,
        Utils.apiHeaders(),
      )
      .then((res) => {
        callback(res.data);
        if (res.data.success && res.data.token) {
          initUserData(res.data);
        }
      })
      .catch((err) => {
        callback(false, err.message);
      });
  };

  const logout = () => {
    setUserData(false);
    Utils.setUserData(false);
  };

  const getServerData = (url, pageInfo = false) => {
    return new Promise((resolve, reject) => {
      axios
        .get(Utils.apiUrl(url), Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            resolve(pageInfo ? res.data : res.data.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  };
  const setServerData = (url, data, method = "put", extraHeaders = {}) => {
    return new Promise((resolve, reject) => {
      axios[method](Utils.apiUrl(url), data, Utils.apiHeaders(extraHeaders))
        .then((res) => {
          if (res.data.success) {
            alert(res.data.id);
            resolve(res.data);
          } else {
            reject(res.data.message);
          }
        })
        .catch(reject);
    });
  };

  const isCertificationRequired = () => {
    let certificationRequired = 1;
    if (
      _.get(userData, "isPG", false) ||
      _.get(userData, "isHR", false) ||
      _.get(userData, "isAMT", false) ||
      _.get(userData, "isHO", false)
    ) {
      certificationRequired =
        _.get(userData, "certification_required", 1) === 1;
    }
    return certificationRequired;
  };

  const isCertified = () => {
    if (!isCertificationRequired()) return true;

    return (
      isCertificationRequired() &&
      _.get(userData, "certificate", false) &&
      _.get(userData, "certificate.attempted", false) &&
      moment(userData.certificate.expires_by).isAfter(moment())
    );
  };

  return (
    <UserContext.Provider
      value={{
        userData,
        goLogin,
        logout,
        getServerData,
        setServerData,
        goSSO,
        phLogin,
        hotelOwnerLogin,
        verifyPhotographerOtp,
        verifyHotelOwnerOtp,
        initUserData,
        isCertificationRequired,
        isCertified,
        siteStatuses,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;

export { UserProvider };
